var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageHotspots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.271 175C58.8481 175 25.2708 141.423 25.2708 100C25.2708 58.5774 58.8481 25 100.271 25C141.693 25 175.271 58.5774 175.271 100C175.271 141.423 141.693 175 100.271 175Z",
    fill: "url(#paint0_linear_26823_852)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8 60.7663C37.8 55.3725 42.1725 51 47.5663 51H145.229C150.622 51 154.995 55.3725 154.995 60.7663V138.896C154.995 144.29 150.622 148.663 145.229 148.663H47.5663C42.1725 148.663 37.8 144.29 37.8 138.896V60.7663ZM89.8867 77.0433C89.8867 84.235 84.0567 90.065 76.8651 90.065C69.6734 90.065 63.8434 84.235 63.8434 77.0433C63.8434 69.8517 69.6734 64.0217 76.8651 64.0217C84.0567 64.0217 89.8867 69.8517 89.8867 77.0433ZM132.667 135.641H60.1084C57.8204 135.641 56.5369 133.245 57.8762 131.526L77.704 110.426C78.7643 109.332 80.6059 109.332 81.7219 110.374L90.8183 120.015L107.895 95.1121C109.067 93.5495 111.522 93.6016 112.582 95.2163L135.123 131.734C136.127 133.505 134.787 135.641 132.667 135.641Z",
    fill: "url(#paint1_linear_26823_852)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8 85C98.8 81.6863 101.486 79 104.8 79H163.8C167.114 79 169.8 81.6863 169.8 85V107C169.8 110.314 167.114 113 163.8 113H138.102C137.444 113 136.827 113.324 136.454 113.867L134.3 117L132.146 113.867C131.773 113.324 131.157 113 130.498 113H104.8C101.486 113 98.8 110.314 98.8 107V85Z",
    fill: "#D4D9E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.11 89H108.49C107.557 89 106.8 88.3286 106.8 87.5C106.8 86.6714 107.557 86 108.49 86H161.11C162.044 86 162.8 86.6714 162.8 87.5C162.8 88.3286 162.044 89 161.11 89Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.11 98H108.49C107.557 98 106.8 97.3286 106.8 96.5C106.8 95.6714 107.557 95 108.49 95H161.11C162.044 95 162.8 95.6714 162.8 96.5C162.8 97.3286 162.044 98 161.11 98Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.092 107H108.508C107.564 107 106.8 106.329 106.8 105.5C106.8 104.671 107.564 104 108.508 104H135.092C136.036 104 136.8 104.671 136.8 105.5C136.8 106.329 136.035 107 135.092 107Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8 126C36.277 126 31.8 121.523 31.8 116C31.8 110.477 36.277 106 41.8 106C47.3231 106 51.8 110.477 51.8 116C51.8 121.523 47.3231 126 41.8 126Z",
    fill: "url(#paint2_linear_26823_852)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8 121C42.5532 121 43.1637 120.389 43.1637 119.636V117.364H45.4364C46.1895 117.364 46.8 116.753 46.8 116C46.8 115.247 46.1895 114.636 45.4364 114.636H43.1637V112.364C43.1637 111.611 42.5532 111 41.8 111C41.0469 111 40.4364 111.611 40.4364 112.364V114.636H38.1637C37.4106 114.636 36.8 115.247 36.8 116C36.8 116.753 37.4106 117.364 38.1637 117.364L40.4364 117.364V119.636C40.4364 120.389 41.0469 121 41.8 121Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.8 140C129.277 140 124.8 135.523 124.8 130C124.8 124.477 129.277 120 134.8 120C140.323 120 144.8 124.477 144.8 130C144.8 135.523 140.323 140 134.8 140Z",
    fill: "url(#paint3_linear_26823_852)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.8 144C127.068 144 120.8 137.732 120.8 130C120.8 122.268 127.068 116 134.8 116C142.532 116 148.8 122.268 148.8 130C148.8 137.732 142.532 144 134.8 144ZM124.8 130C124.8 135.523 129.277 140 134.8 140C140.323 140 144.8 135.523 144.8 130C144.8 124.477 140.323 120 134.8 120C129.277 120 124.8 124.477 124.8 130Z",
    fill: "#F7CE46"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.8 135C135.553 135 136.164 134.389 136.164 133.636V131.364H138.436C139.19 131.364 139.8 130.753 139.8 130C139.8 129.247 139.19 128.636 138.436 128.636H136.164V126.364C136.164 125.611 135.553 125 134.8 125C134.047 125 133.436 125.611 133.436 126.364V128.636H131.164C130.411 128.636 129.8 129.247 129.8 130C129.8 130.753 130.411 131.364 131.164 131.364L133.436 131.364V133.636C133.436 134.389 134.047 135 134.8 135Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.8 64C119.277 64 114.8 59.523 114.8 54C114.8 48.477 119.277 44 124.8 44C130.323 44 134.8 48.477 134.8 54C134.8 59.523 130.323 64 124.8 64Z",
    fill: "url(#paint4_linear_26823_852)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.8 59C125.553 59 126.164 58.3895 126.164 57.6364V55.3636H128.436C129.19 55.3636 129.8 54.7531 129.8 54C129.8 53.2469 129.19 52.6364 128.436 52.6364H126.164V50.3636C126.164 49.6105 125.553 49 124.8 49C124.047 49 123.436 49.6105 123.436 50.3636V52.6364H121.164C120.411 52.6364 119.8 53.2469 119.8 54C119.8 54.7531 120.411 55.3636 121.164 55.3636L123.436 55.3636V57.6364C123.436 58.3895 124.047 59 124.8 59Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26823_852",
    x1: 25.2708,
    y1: 36.7188,
    x2: 168.239,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26823_852",
    x1: 96.3976,
    y1: 51,
    x2: 96.3976,
    y2: 148.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26823_852",
    x1: 33.9875,
    y1: 106,
    x2: 57.1156,
    y2: 120.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26823_852",
    x1: 126.988,
    y1: 120,
    x2: 150.116,
    y2: 134.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26823_852",
    x1: 116.988,
    y1: 44,
    x2: 140.116,
    y2: 58.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageHotspots);
export default __webpack_public_path__ + "static/media/Image-Hotspots.2c116cc66d83bbcc6bce23aaa0110a72.svg";
export { ForwardRef as ReactComponent };